<template>
  <v-card class="hc__rounded-card">
    <v-card-title>
      <div class="hc__box-title py-4 pl-4">
        <p>Centro de ayuda</p>
        <h1 class="hc__blue-text headline">{{ category.name }}</h1>
      </div>
    </v-card-title>

    <v-list v-for="(subcategory, i) in category.subcategories" :key="i"> 
      <v-list-tile
        :key="subcategory.id"
        :to="`${$route.path}/${subcategory.slug}`"
        class="comment-list pl-3"
        v-if="subcategory.name != 'false'"
      >
        <v-list-tile-content>
          <div>
            {{ subcategory.name }}
          </div>
        </v-list-tile-content>

        <v-list-tile-action>
           <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/chevron-right.svg" class="chevron-right" alt=""></img>
        </v-list-tile-action>
      </v-list-tile>
      
      <v-divider></v-divider>
    </v-list>
  </v-card>
</template>
<script>
export default {
  props: {
    category: { type: Object, required: true }
  }
}
</script>
<style lang="css">
.comment-list > .v-list__tile {
  height: 100% !important;
  padding: 10px 10px !important;
}

.hc__box-title {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  border-radius: 8px;
  border: 1px solid rgb(225, 225, 225);
}


.hc__rounded-card{
  border-radius: 0.5rem
}
.chevron-right{
  width: 40px;
  filter: invert(85%) sepia(92%) saturate(6513%) hue-rotate(117deg) brightness(96%) contrast(88%);
}
</style>
